import * as React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Success from './pages/Success';
import Failed from './pages/Failed';

import './App.css';

type Props = {};
type State = {
  email: string | null;
};
class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const searchParams = new URLSearchParams(document.location.search);
    this.state = {
      email: searchParams.get('email'),
    };
  }

  render() {
    const { email } = this.state;
    return (
      <div className="App">
        <Router>
          <Switch>
            <Route exact path="/success">
              <Success email={email} />
            </Route>
            <Route path="/">
              <Failed />
            </Route>
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;
